export default __webpack_public_path__ + "static/media/designer-man.4b71fe44.svg";